module.exports = __webpack_public_path__ + "static/media/gururaj.775e58ec.png";